// Utility to clear any rogue service workers that might be intercepting API calls
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
        for (let registration of registrations) {
            console.warn('🗑️ Unregistering rogue service worker:', registration);
            registration.unregister();
        }
    }).catch(err => {
        console.error('❌ Service Worker unregistration failed:', err);
    });
}
